import { application } from "./application.js";

// 共通
import AriaDisabledController from "./aria_disabled_controller.js";
application.register("aria-disabled", AriaDisabledController);
import ToggleController from "./toggle_controller.js";
application.register("toggle", ToggleController);
import SmoothScrollController from "./smooth_scroll_controller.js";
application.register("smooth_scroll", SmoothScrollController);

import ToastController from "./toast_controller.js";
application.register("toast", ToastController);
import TextCopyController from "./text_copy_controller.js";
application.register("text_copy", TextCopyController);

// ヘッダー
import HeaderController from "./header_controller.js";
application.register("header", HeaderController);

// チケット選択
import TicketSelectSubmitController from "./ticket_select_submit_controller.js";
application.register("ticket_select_submit", TicketSelectSubmitController);

// 重要なお知らせ（TOPリニューアル）
import NoticeToggleController from "./notice_toggle_controller.js";
application.register("notice-toggle", NoticeToggleController);

// バナー
import BannerHeroSliderController from "./banner_hero_slider_controller.js";
application.register("banner_hero_slider", BannerHeroSliderController);
import BannerMediumSliderController from "./banner_medium_slider_controller.js";
application.register("banner_medium_slider", BannerMediumSliderController);
import BannerSmallSliderController from "./banner_small_slider_controller.js";
application.register("banner_small_slider", BannerSmallSliderController);

// 終了したイベント
import GetFinishedEventController from "./get_finished_event_controller.js";
application.register("get-finished-event", GetFinishedEventController);

// Modal
import TargetModalController from "./target_modal_controller.js";
application.register("target_modal", TargetModalController);

// RadioToggle
import RadioToggleController from "./radio_toggle_controller.js";
application.register("radio_toggle", RadioToggleController);

// 座席選択
import UpdateSeatSelectBoxexController from "./update_seat_select_boxes_controller.js";
application.register("update_seat_select_boxes", UpdateSeatSelectBoxexController);
import UpdateSeatRowSelectBoxesController from "./update_seat_row_select_boxes_controller.js";
application.register("update_seat_row_select_boxes", UpdateSeatRowSelectBoxesController);

// 詳細検索
import HandleSearchController from "./handle_search_controller.js";
application.register("handle-search", HandleSearchController);
import HandleSearchRadioSetController from "./handle_search_radio_set_controller.js";
application.register("handle-search-radio-set", HandleSearchRadioSetController);

// イベント詳細
import EventDetailSliderController from "./event_detail_slider_controller.js";
application.register("event_detail_slider", EventDetailSliderController);
import EventDetailModalSliderController from "./event_detail_modal_slider_controller.js";
application.register("event_detail_modal_slider", EventDetailModalSliderController);
import EventDetailNavController from "./event_detail_nav_controller.js";
application.register("event_detail_nav", EventDetailNavController);
import EventShareController from "./event_share_controller.js";
application.register("event_share", EventShareController);
import ToggleMoreController from "./toggle_more_controller.js";
application.register("toggle_more", ToggleMoreController);

// password
import PasswordVisibilityController from "./password_visibility_controller.js";
application.register("password-visibility", PasswordVisibilityController);

// residence
import ResidenceController from "./residence_controller.js";
application.register("residence", ResidenceController);

// GoogleMap
import GoogleMapShowController from "./google_map_show_controller.js";
application.register("google-map-show", GoogleMapShowController);

// プレビュー
import PreviewController from "./preview_controller.js";
application.register("preview", PreviewController);
import ModalPreviewController from "./modal_preview_controller.js";
application.register("modal-preview", ModalPreviewController);

// DatePicker
import DatePickerController from "./date_picker_controller.js";
application.register("date-picker", DatePickerController);

// Newsletter
import NewsletterController from "./newsletter_controller.js";
application.register("newsletter", NewsletterController);

// Notification
import EditNewsListController from "./edit_news_list_controller.js";
application.register("edit-news-list", EditNewsListController);

import TopEventSliderController from "./top_event_slider_controller.js";
application.register("top-event-slider", TopEventSliderController);

import TopSearchCategoryLinkController from "./top_search_category_link_controller.js";
application.register("top-search-category-link", TopSearchCategoryLinkController);

// 会員登録
import RegistrationController from "./registration_controller.js";
application.register("registration", RegistrationController);

// QRcode
import QrcodeController from "./qrcode_controller.js";
application.register("qrcode", QrcodeController);

// お気に入り
import FavoriteEventController from "./favorite_event_controller.js";
application.register("favorite-event", FavoriteEventController);

// 利用規約同意
import TermController from "./term_controller.js";
application.register("term", TermController);

// モーダル表示
import ShowModalController from "./show_modal_controller.js";
application.register("show-modal", ShowModalController);

// フォームの自動submit
import SubmitFormController from "./submit_form_controller.js";
application.register("submit-form", SubmitFormController);

// Credit決済のFrom制御
import CreditPaymentController from "./credit_payment_controller.js";
application.register("credit_payment", CreditPaymentController);

// あと払い決済のFrom制御
import AtonePaymentController from "./atone_payment_controller.js";
application.register("atone_payment", AtonePaymentController);

// 決済方法のJSFormコントロール制御
import PaymentMethodController from "./payment_method_controller.js";
application.register("payment_method", PaymentMethodController);

// スクロールバー処理
import SimplebarController from "./simplebar_controller";
application.register("simplebar", SimplebarController);

// LPページ処理
import ToggleScrollController from "./toggle_scroll_controller";
application.register("toggle-scroll", ToggleScrollController);

// GTMタグ
import GtmSignUpController from "./gtm_sign_up_controller";
application.register("gtm-sign-up", GtmSignUpController);
import GtmLoginController from "./gtm_login_controller";
application.register("gtm-login", GtmLoginController);
import GtmPurchaseController from "./gtm_purchase_controller";
application.register("gtm-purchase", GtmPurchaseController);
import GtmSpaPageiewController from "./gtm_spa_pageview_controller.js";
application.register("gtm-spa-pageview", GtmSpaPageiewController);

// ダブルサブミット処理
import ClickSubmitController from "./click_submit_controller.js";
application.register("click-submit", ClickSubmitController);

// 電話番号認証
import PhoneNumbersController from "./phone_numbers_controller.js";
application.register("phone-numbers", PhoneNumbersController);
import PhoneNumbersModalController from "./phone_numbers_modal_controller.js";
application.register("phone-numbers-modal", PhoneNumbersModalController);
import PhoneNumbersSmsController from "./phone_numbers_sms_controller.js";
application.register("phone-numbers-sms", PhoneNumbersSmsController);
import CallbackDummyController from "./callback_dummy_controller.js";
application.register("callback-dummy", CallbackDummyController);

// マイチケット
import MyTicketsController from "./my_tickets_controller.js";
application.register("my-tickets", MyTicketsController);

// 連席アラート
import NonSeatingAlertController from "./nonseating_alert_controller.js";
application.register("nonseating-alert", NonSeatingAlertController);

// Back/forward cache の無効化
import ReloadOnHistoryController from "./reload_on_history_controller.js";
application.register("reload-on-history", ReloadOnHistoryController);

// インベントアクセス制限のカウントダウン
import CountdownController from "./countdown_controller.js";
application.register("countdown", CountdownController);

// ブラウザバック時にページをリロードさせる
import BackReloadController from "./back_reload_controller.js";
application.register("back-reload", BackReloadController);
